import { Dialog, DialogContent } from '@mui/material';
import { MprcDialogTitleClose } from 'components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PostContent } from 'views/lms/student/EnrollmentView/Course/ContentComponents/post/PostContent';

interface IProps {
    publicationId: string;
    open: boolean;
    onClose: () => void;
}

export const PostExclusiveViewer: React.FC<IProps> = ({ publicationId, open, onClose }) => {

    const { t } = useTranslation("shared");

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="sm"
            onClose={onClose}
        >
            <MprcDialogTitleClose title={t("SysObjects.Publication")} shrinkPadding onClose={onClose} />
            <DialogContent sx={{ p: 1.5 }}>
                <PostContent
                    publicationId={publicationId}
                    onComplete={() => { }}
                />
            </DialogContent>
        </Dialog>
    );
};
